import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { Router } from "@angular/router";
import { AuthService } from "../../features/auth/services/auth/auth.service";

export function AuthInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn) {
    const authService = inject(AuthService);
    const token = authService.userToken;
    const router = inject(Router);


    const clonedRequest = token ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : request;

   // return next(clonedRequest);

   return next(clonedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        authService.logout();
        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
}